import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import pageTitle from 'ember-page-title/helpers/page-title';
import WrModal from 'ember-wiser/components/modal';
import SoftLCP from 'parog-web/components/soft-lcp';
import type ApplicationController from 'parog-web/controllers/application';
import LegacyModal from 'ui-kit/components/legacy-modal';

interface Signature {
  Args: {
    controller: ApplicationController;
  };
}

const ApplicationTemplate: TOC<Signature> = <template>
  <SoftLCP />
  {{pageTitle (concat @controller.session.productName ' - Sêmeia')}}

  <WrModal id='login-modal' class='[&>:first-child]:bg-black/40' />
  <WrModal id='medics-web-modal' class='[&>:first-child]:bg-white/70' />
  <LegacyModal />

  {{outlet}}
</template>;

export default ApplicationTemplate;
